import React, { useCallback } from 'react';

function useDropHandler(dropHandler, dragStartHandler) {
  const [dropping, setDropping] = React.useState(false);
  const dragEnterCount = React.useRef(0);
  const onDragOver = useCallback(e => {
    e.preventDefault();
  }, []);
  const onDragEnter = useCallback(e => {
    if (dragEnterCount.current === 0) {
      setDropping(true);

      if (dragStartHandler) {
        dragStartHandler(e);
      }
    }

    dragEnterCount.current += 1;
  }, [dragStartHandler]);
  const onDragLeave = useCallback(() => {
    dragEnterCount.current -= 1;

    if (dragEnterCount.current === 0) {
      setDropping(false);
    }
  }, []);
  const onDrop = useCallback(e => {
    dragEnterCount.current = 0;
    setDropping(false);
    dropHandler(e);
    e.preventDefault();
  }, [dropHandler]);
  return {
    dropping,
    onDragOver,
    onDragEnter,
    onDragLeave,
    onDrop
  };
}

export { useDropHandler as default };
//# sourceMappingURL=useDropHandler.js.map
